import { Button, message, Modal } from "antd"
import { useEffect, useState } from "react"
import styles from "./CareerDiagnosis.module.css"
import "./CareerDiagnosis.scss"
import axios from "axios"
import { selectCurrentUser } from "../../../../redux/user/user.selectors"
import { useSelector } from "react-redux"

const CareerDiagnosis = ({ userProgressCareerDiagnosis }) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [type, setType] = useState(null) // food | career
  const currentUser = useSelector(selectCurrentUser)

  const handleOpenModal = (selectedType) => {
    if (
      userProgressCareerDiagnosis &&
      userProgressCareerDiagnosis.checkUserFoodPath.isProgress
    ) {
      setType(selectedType)
      setIsModalOpen(true)
    } else {
      handleRedirectUrl("0", selectedType)
    }
  }

  const handleClose = () => {
    setIsModalOpen(false)
    setType(null)
  }

  const handleRedirectUrl = (isContinue, type) => {
    if (!currentUser?.token) {
      message.warning("Silakan login terlebih dahulu")
      return
    }

    const payload = JSON.stringify({
      isContinue,
      productType: type,
    })
    console.log("payload", payload)
    axios({
      method: "post",
      url: `/career-diagnosis/portal`,
      headers: {
        Authorization: `Bearer ${currentUser.token}`,
        "Content-Type": "application/json",
      },
      data: payload,
    })
      .then((response) => {
        const data = response.data.data
        if (data && data.portalToken) {
          const url = `https://career-diagnosis.mindoeducation.co.id/portal?token=${data.portalToken}`
          window.location.href = url
        }
      })
      .catch((err) => {
        console.error("Error :", err)
      })
  }

  useEffect(() => {
    console.log("user progress", userProgressCareerDiagnosis)
  }, [userProgressCareerDiagnosis])

  return (
    <>
      <article id="home-page__careerDiagnosis">
        <div className="container">
          <div className={styles.CareerDiagnosis} data-aos="fade-up">
            <h2 className={styles.tittle}>Ramalan Karir & Diagnosis Skill</h2>

            <p className={styles.text}>
              Warga Mindo masih bingung cocok berkarir di posisi apa? Ikuti dulu
              2 games untuk kenali potensi diri & ukur skill!
              <br />
              <br />
              "Ramalan Karir" buat cari tau rekomendasi karir apa yang cocok
              untuk warmindo (QC/QA/R&D), dan "Diagnosa Skill" buat sejauh mana
              persiapan warmindo untuk posisi yang sudah dipilih (QC/QA/R&D){" "}
              <br />                            
              <br />
              Yuk test sekarang! Bisa mulai dari Ramalan Karir dulu, terus
              lanjut ke Diagnosa Skill!
            </p>

            <div className={styles.btnGroup}>
              <div className={styles.btn}>
                <Button onClick={() => handleOpenModal("FOOD_PATH")}>
                  Ramalan Karir
                </Button>
              </div>

              <div className={styles.btn}>
                <Button onClick={() => handleOpenModal("CAREER_DIAGNOSIS")}>
                  Diagnosis Skill
                </Button>
              </div>
            </div>
          </div>
        </div>
      </article>

      {/* MODAL */}
      <Modal open={isModalOpen} onCancel={handleClose} footer={null} centered>
        <div className={styles.modalContent}>
          <h3>{type === "FOOD_PATH" ? "Food Path" : "Career Diagnosis"}</h3>

          <p>
            Kamu masih punya progress sebelumnya. Apakah ingin melanjutkan yang
            kemarin?
          </p>

          <div className={styles.modalActions}>
            <Button
              onClick={() => {
                // nanti: lanjut progress\
                handleRedirectUrl("1", type)
              }}>
              Lanjutkan
            </Button>

            <Button
              type="primary"
              className={styles.btn}
              onClick={() => {
                // nanti: reset & mulai baru
                handleRedirectUrl("0", type)
              }}>
              Mulai Ulang
            </Button>
          </div>
        </div>
      </Modal>
    </>
  )
}

export default CareerDiagnosis
